import axios from '../utils/axios'
let simulateApi={
    // 分页获取提醒信息
    getSimulationRecord(params, success){
        axios('/simulate/getsimulationrecord', params, success)
    },
    
    // 新增
    addSimulationRecord(params, success){
        axios('/simulate/addsimulationrecord', params, success)
    },
    
    // 删除
    delSimulationRecord(params, success){
        axios('/simulate/delsimulationrecord', params, success)
    },
    
}
export default simulateApi


// WEBPACK FOOTER //
// ./src/api/simulate.js